/**
 * This is a simple phone number validator that checks whether a string is 10
 * digit phone number.
 * @param unformattedPhoneNumber Unformatted 10 digit phone number.
 * @returns Whether or not phone number is valid.
 */
export function phoneNumberIsValid(unformattedPhoneNumber) {
  return (
    unformattedPhoneNumber.length === 10 && /^\d+$/.test(unformattedPhoneNumber)
  );
}

/**
 * Unformats a string phone number by removing all non-numeric characters.
 * @param formattedPhoneNumber Formatted phone number.
 * @returns Unformatted phone number.
 * */
export function unformatPhoneNumber(formattedPhoneNumber) {
  return formattedPhoneNumber.replace(/\D/g, '');
}

/**
 * Simple phone number formatter that formats string into (xxx) xxx-xxxx format.
 * @param phoneNumberString 10 digit numbers.
 * @returns The formatted phone number in (xxx) xxx-xxxx format.
 */
export function formatPhoneNumber(phoneNumberString) {
  const unformattedPhoneNumber = unformatPhoneNumber(phoneNumberString);
  const areaCode = unformattedPhoneNumber.substring(0, 3);
  const middle = unformattedPhoneNumber.substring(3, 6);
  const last = unformattedPhoneNumber.substring(6);

  if (unformattedPhoneNumber.length > 6) {
    return `(${areaCode}) ${middle}-${last}`;
  } else if (unformattedPhoneNumber.length > 3) {
    return `(${areaCode}) ${middle}`;
  } else if (unformattedPhoneNumber.length > 0) {
    return `(${areaCode}`;
  }
  return '';
}
